import React from 'react';
import styled from 'styled-components/macro';

import PropTypes from 'prop-types';

const smallSize = 24, largeSize = 80;

const LogoContainer = styled.div`
    max-width: 125px;
    max-height: ${props => (props.isSmall ? smallSize : largeSize)}px;
    flex: 0 0 ${props => (props.isSmall ? smallSize : largeSize)}px;
    margin-bottom: ${props => props.marginBottom || '10px'};
    cursor: pointer;
`;

const Logo = styled.img`
    max-width: 125px;
    max-height: ${props => (props.isSmall ? smallSize : largeSize)}px;
`;

const PartnerLogo = props => (
    <LogoContainer marginBottom={props.marginBottom} isSmall={props.isSmall || false}>
        <Logo
            src={props.logoUrl}
            onClick={props.onClick}
            isSmall={props.isSmall || false}
        />
    </LogoContainer>
);

PartnerLogo.propTypes = {
    logoUrl: PropTypes.string,
    marginBottom: PropTypes.string,
    onClick: PropTypes.func,
    isSmall: PropTypes.bool
};

export default PartnerLogo;
